/**
 * Utilidades para categorizar y asignar insignias (badges) a los conductores
 * en la lista de turnos (ShiftDriversList).
 */

export const DRIVER_CATEGORIES = {
  ALL: 'all',
  FASTEST: 'fastest',
  FAMOUS: 'famous',
  MOTO: 'moto',
  CAR: 'carro',
};

export const CATEGORY_TABS = [
  { id: DRIVER_CATEGORIES.ALL, label: 'Todos' },
  { id: DRIVER_CATEGORIES.FASTEST, label: 'Más rápido' },
  { id: DRIVER_CATEGORIES.FAMOUS, label: 'Top Calificado' },
  { id: DRIVER_CATEGORIES.MOTO, label: 'Motos' },
  { id: DRIVER_CATEGORIES.CAR, label: 'Carros' },
];

/**
 * Filtra y/o ordena la lista de conductores según la categoría seleccionada
 */
export function categorizeDrivers(drivers = [], category = DRIVER_CATEGORIES.ALL) {
  if (!Array.isArray(drivers) || drivers.length === 0) return [];
  const list = [...drivers];

  switch (category) {
    case DRIVER_CATEGORIES.FASTEST:
      return list.sort((a, b) => {
        const distA = a.distance_km != null ? Number(a.distance_km) : Infinity;
        const distB = b.distance_km != null ? Number(b.distance_km) : Infinity;
        return distA - distB;
      });

    case DRIVER_CATEGORIES.FAMOUS:
      return list.sort((a, b) => {
        const ratingA = a.rating != null ? Number(a.rating) : 0;
        const ratingB = b.rating != null ? Number(b.rating) : 0;
        if (ratingB !== ratingA) {
          return ratingB - ratingA;
        }
        const tripsA = a.total_trips != null ? Number(a.total_trips) : 0;
        const tripsB = b.total_trips != null ? Number(b.total_trips) : 0;
        return tripsB - tripsA;
      });

    case DRIVER_CATEGORIES.MOTO:
      return list.filter(d => (d.vehicle_type || '').toLowerCase() === 'moto');

    case DRIVER_CATEGORIES.CAR:
      return list.filter(d => (d.vehicle_type || '').toLowerCase() === 'carro');

    case DRIVER_CATEGORIES.ALL:
    default:
      return list;
  }
}

/**
 * Calcula qué badges aplican para un conductor determinado
 */
export function getDriverBadges(driver, allDrivers = []) {
  if (!driver) return [];
  const badges = [];

  // Badge 1: Verificado INTT (solo si el registro en BD está verificado)
  if (driver.is_verified || driver.is_approved || driver.intt_verified) {
    badges.push({
      type: 'verified',
      label: 'INTT Verificado',
      bg: 'rgba(6, 182, 212, 0.12)',
      color: '#0891b2',
      border: '1px solid rgba(6, 182, 212, 0.3)',
    });
  }

  if (!Array.isArray(allDrivers) || allDrivers.length === 0) return badges;

  // Badge 2: Más rápido (el conductor más cercano con distancia válida)
  const validDistances = allDrivers
    .filter(d => d.distance_km != null && !isNaN(d.distance_km))
    .map(d => Number(d.distance_km));

  if (validDistances.length > 0) {
    const minDistance = Math.min(...validDistances);
    if (driver.distance_km != null && Number(driver.distance_km) === minDistance) {
      badges.push({
        type: 'fastest',
        label: 'Más rápido',
        bg: 'rgba(245, 158, 11, 0.12)',
        color: '#d97706',
        border: '1px solid rgba(245, 158, 11, 0.3)',
      });
    }
  }

  // Badge 3: Más destacado (rating >= 4.8 o top viajes)
  const rating = Number(driver.rating || 0);
  const totalTrips = Number(driver.total_trips || 0);
  const maxTrips = Math.max(...allDrivers.map(d => Number(d.total_trips || 0)));

  if (rating >= 4.8 || (maxTrips > 0 && totalTrips === maxTrips)) {
    badges.push({
      type: 'famous',
      label: rating >= 4.9 ? 'Top Calificado' : 'Destacado',
      bg: 'rgba(14, 171, 176, 0.12)',
      color: '#0EABB0',
      border: '1px solid rgba(14, 171, 176, 0.3)',
    });
  }

  return badges;
}
